import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { X } from "react-feather";

import { INVITE_USERS } from '../../constants/AppConstants';
import UserMultiSelect from '../UserMultiSelect/UserMultiSelectContainer';

import { isDirectMessage, isPrivateChannel } from '../../helpers/ChatUtils';

export default class ChatInvite extends Component {

  static propTypes = {
    chat: PropTypes.object,
    addUsersToChannel: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.state = {
      userIds: []
    }
  }

  selectedUsers = userIds => this.setState({ userIds });

  clearSelectedUsers = () => this.setState({ userIds: [] });

  inviteUsers = () => {
    this.props.addUsersToChannel(this.props.chat.id, this.state.userIds);
    this.clearSelectedUsers();
  };

  getChatTypeName = chat => {
    if (isDirectMessage(chat)) return 'Direct Message';
    if (isPrivateChannel(chat)) return 'Private Channel';
    return 'Public Channel';
  };

  render() {
    const { chat } = this.props;
    const { userIds } = this.state;
    const enabled = this.state.userIds.length > 0;
    const chatType = this.getChatTypeName(chat);

    return (
      <div className="chat-invite-panel" data-qa="inviteToChat">
        {chat &&
        <Fragment>
          <div className="panel-title" data-qa="chatInviteHeading">
            <h1>{INVITE_USERS}</h1>
            <Link
              to={`/chat/${chat.id}/details`}
              className="closeButton"
              data-qa="chatInviteClose"
            >
              <X size={24}/>
            </Link>
          </div>
          <div className="panel-content">
            {chat.name && <h2>{chat.name}</h2>}
            <h5>{chatType}</h5>
            <UserMultiSelect
              qaId="chatInvite"
              excludeSelfUser
              onChange={this.selectedUsers}
              onClearAll={this.clearSelectedUsers}
              usersToExclude={chat.users}
              value={userIds}
            />
            <button
              className="btn primary"
              type="submit"
              onClick={this.inviteUsers}
              disabled={!enabled}
            >
              Invite
            </button>
          </div>
        </Fragment>
        }
      </div>
    );
  }
};
